// auto-generated by {apiBaseUrl}/tools/typescriptmodels
import { ProductionType } from "../../data/talent-core/production-type";
import { ProductionStatus } from "../../data/talent-core/production-status";
import { ResourceSearchResult } from "../result/resource-search-result";
import { ResourceType } from "../../data/talent-core/resource-type";
import { ProductionDocument } from "./documents/production-document";
import { ItemEnvelope } from "./base/item-envelope";

export class ProductionEnvelope extends ItemEnvelope {
	public constructor(jsonEnvelope: any) {
		super(jsonEnvelope, "Production");
		if (jsonEnvelope) {
			this.ProductionTypes = jsonEnvelope.ProductionTypes;
			this.ProductionStatuses = jsonEnvelope.ProductionStatuses;
			this.Resources = jsonEnvelope.Resources;
			this.ResourceTypes = jsonEnvelope.ResourceTypes;
			this.Document = jsonEnvelope.Document;
			this.CreatedOnUTC = jsonEnvelope.CreatedOnUTC;
			this.CreateUserUID = jsonEnvelope.CreateUserUID;
			this.ModifiedOnUTC = jsonEnvelope.ModifiedOnUTC;
			this.ModifyUserUID = jsonEnvelope.ModifyUserUID;
		}
	}
	public ProductionTypes: ProductionType[] = [];
	public ProductionStatuses: ProductionStatus[] = [];
	public Resources: ResourceSearchResult[] = [];
	public ResourceTypes: ResourceType[] = [];
	public override Document: ProductionDocument = new ProductionDocument();
	public override get ItemId(): number { return this.Document.Item.ProductionId; }
	public override get ItemName(): string { return this.Document.Item.Name; }
}